import { render, staticRenderFns } from "./CommunicationManagement.vue?vue&type=template&id=3c5461c8&scoped=true"
import script from "./CommunicationManagement.vue?vue&type=script&lang=js"
export * from "./CommunicationManagement.vue?vue&type=script&lang=js"
import style0 from "./CommunicationManagement.vue?vue&type=style&index=0&id=3c5461c8&prod&lang=scss"
import style1 from "./CommunicationManagement.vue?vue&type=style&index=1&id=3c5461c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5461c8",
  null
  
)

export default component.exports